import React, { useCallback } from 'react'
import { styles } from './styles'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(styles)

export const LuaButton = React.memo(({ emoji, onClick, isUnicode }) => {
    const classes = useStyles()
    const luaClick = useCallback(() => {
        onClick({ emoji, isUnicode })
    }, [onClick, emoji, isUnicode])

    return (
        <div className={classes.luaButton} onClick={luaClick} id="lua-btn">
            {isUnicode ? (
                <span role="img" aria-label="grinning-face">
                    {emoji}
                </span>
            ) : (
                <img src={emoji} alt="emoji" />
            )}
        </div>
    )
})
